import { useSyncExternalStore } from 'react';

// Where the video-potential score of a note is shown outside YouTube Manager. Both are off until
// switched on in the Manager's map tab; the choice is remembered on this device.
export interface VideoScoreDisplay { canvas: boolean; note: boolean }

const KEY = 'sb_video_score_display_v1';
const listeners = new Set<() => void>();
let state: VideoScoreDisplay = (() => {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || '{}');
        return { canvas: raw.canvas === true, note: raw.note === true };
    } catch { return { canvas: false, note: false }; }
})();

export function setVideoScoreDisplay(patch: Partial<VideoScoreDisplay>) {
    state = { ...state, ...patch };
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* still applies for this session */ }
    listeners.forEach(l => l());
}

export function useVideoScoreDisplay(): VideoScoreDisplay {
    return useSyncExternalStore(
        l => { listeners.add(l); return () => { listeners.delete(l); }; },
        () => state,
        () => state,
    );
}
